/**
 * Cookie 类别
 */
enum CookieCategory {
  /** 必要 Cookie */
  STRICTLY_NECESSARY = 'strictly_necessary',
  /** 性能 Cookie */
  PERFORMANCE = 'performance',
  /** 功能 Cookie */
  FUNCTIONAL = 'functional',
  /** 目标 Cookie */
  TARGETING = 'targeting'
}

export default CookieCategory
